<template>
    <div class="conditional">
        
        <div class="conditional__response conditional__response--ifelse v--25">
            
            <!--
            {{ instance }}
            {{ siloData.user.modules[instance.conditions[0].field] }}
            {{ haveConditionsBeenMet }}
             -->

            <div class="conditional__response__container v--20">
                <div v-for="(c, i) in instance.conditions" :key="i" class="conditional__panel">
                    <div v-if="isConditionMet(c)" class="v--50">
                        <div v-for="(inst, index) in c.conditions_met_panels.widgets" :key="index" class="conditional__panel">
                            <Kudo v-if="inst.panels_info.class === 'Kudo'" :instance="inst" :siloData="siloData" :active="active" />
                            <PanelText v-if="inst.panels_info.class === 'Text_Panel'" :instance="inst" :siloData="siloData" :active="active" />
                            <PanelForm v-if="inst.panels_info.class === 'Form'" :instance="inst" :siloData="siloData" :slide="slide" :isLast="isLast" @next="next" @processing="setProcessing" @refreshData="refreshData" @setNextOnRefresh="setNextOnRefresh" @toMenu="$emit('toMenu')"/>
                            <Forwarder v-if="inst.panels_info.class === 'Forwarder'" :instance="inst" :siloData="siloData" :active="active" @next="next" @prev="$emit('prev')" />
                            <PanelVariable v-if="inst.panels_info.class === 'Variable_Panel'" :instance="inst" :siloData="siloData"/>
                        </div>
                        <div class="conditional__buttons r r--halign-center">
                            <template v-if="!isLast">
                                <button v-if="!hideButton(c.conditions_met_panels)" class="ms__next btn btn--solid" @click="next">Next</button>
                            </template>
                            <template v-else>
                                <button v-if="!hideButton(c.conditions_met_panels)" class="ms__home btn btn--solid" @click="finish">Finish</button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import PanelText from "@c/panels/PanelText.vue";
import PanelForm from "@c/panels/PanelForm.vue";
import Forwarder from "@c/panels/Forwarder.vue";
import Kudo from "@c/panels/Kudo.vue";
import PanelVariable from "@c/panels/PanelVariable.vue";
export default {
    components: {
        PanelText,
        PanelForm,
        Forwarder,
        Kudo,
        PanelVariable,
    },
    data() {
        return {}
    },        
    props: {
        siloData: Object,
        instance: Object,
        active: Boolean, 
        slide: Object,
        isLast: Boolean,
    },
    computed: {
        // Runs through array to see if we've met our conditions
        haveConditionsBeenMet() {
            if (this.active === false) { return false; }
            let returned = true;
            // For now, if any of these is false, the condition is not met
            // ! THIS HAS TO BE REWRITTEN SO THAT EVERY CONDITION HAS TO BE PASSED
            /*
            this.instance.conditions.forEach(condition => {
                if (this.isConditionMet(condition) === false) {
                    returned = false;
                }
            });
            */

            // Loop with break idea taken from : https://stackoverflow.com/questions/2641347/short-circuit-array-foreach-like-calling-break
            // You can't break out of a foreach loop, but you can a for loop
            // As soon as we catch a false statement, we want to break out
            // Because they ALL need to be true
            for (const condition of this.instance.conditions) {
                if (this.isConditionMet(condition) === false) {
                    returned = false;
                    break;
                }
            }

            return returned;
        },
    },
    methods: {
        // Let's you know if a single condition has been met
        isConditionMet(condition) {
            let returned = false;

            // Get field value from silodata
            let check = this.siloData.user.modules[condition.field];

            // Determine if it's an array and use the first instance if it is
            let check_value = Array.isArray(check) ? check[0] : check;

            // In the check from the panel it can only be a string
            if (check_value === null || check_value === "") {
                check_value = "null";
            }

            if (condition.operator === 'is') {
                if (condition.value === check_value) {
                    returned = true;
                }
            }

            if (condition.operator === 'isnot') {
                if (condition.value !== check_value) {
                    returned = true;
                }
            }

            /*
            console.log('%cchecking is values', 'color:green;');
            console.log({
                'slide':this.slide.order,
                'check field':condition.field,
                'check value':check_value,
                'operator':condition.operator,
                'value':condition.value,
                'condition met':returned
            });
            */

            return returned;
        },
        next() {
            this.$emit('next');
        },
        finish() {
            // Probably have to do something here with logging lesson completion
            this.$emit('toMenu');
        },
        setProcessing(state) {
            this.$emit('processing', state);
        },
        refreshData(onComplete = null) {
            this.$emit('refreshData', onComplete);
        },
        playingVideo() {
            this.$emit('playingVideo');
        },
        setNextOnRefresh() {
            console.log('MCONDITIONAL EMITTING SET NEXT ON REFRESH');
            this.$emit('setNextOnRefresh');
        },
        hideButton(panels_array) {
            let returned = false;

            // Loop through panel widgets
            panels_array.widgets.forEach(instance => {
                // If we find a form panel, set the return to true
                if (instance.panels_info.class === 'Form' || instance.panels_info.class === 'Video_Team_Panel' || instance.panels_info.class === 'Forwarder') {
                    returned = true;
                }
            });

            return returned;
        },
    }

}
</script>

<style lang="scss" scoped>

</style>